import * as find from './reducers/find';
import * as create from './reducers/create';
import * as open from './reducers/open';
import * as update from './reducers/update';
import * as getTransactions from './reducers/get-transactions';
import * as topUp from './reducers/top-up';
import * as withdraw from './reducers/withdraw';
import * as adjust from './reducers/adjust';
import * as setLimit from './reducers/set-limit';
import * as setWageringLimit from './reducers/set-wagering-limit';
import * as selfExclusion from './reducers/self-exclusion';
import * as playBreak from './reducers/play-break';
import * as realityCheck from './reducers/reality-check';
import * as getAssetFlows from './reducers/get-asset-flows';
import * as removePaymentMethods from './reducers/remove-payment-method';
import * as getCounters from './reducers/get-counters';
import * as currencyValidation from './reducers/currency-validation';
import * as referalValidation from './reducers/referal-validation';
import * as getFreeBetCredits from './reducers/get-freebet-credits';
import * as addFreeBetCredit from './reducers/add-freebet-credit.js';
import * as removeFreeBetCredit from './reducers/remove-freebet-credit.js';
import * as getFreeBetHistory from './reducers/get-freebet-history';
import * as requestReactivation from './reducers/request-reactivation';
import * as reactivate from './reducers/reactivate';

// eslint-disable-next-line import/no-default-export
export default {
    CUSTOMERS_FIND_REQUEST: find.request,
    CUSTOMERS_CREATE_REQUEST: create.request,
    CUSTOMERS_OPEN_REQUEST: open.request,
    CUSTOMERS_UPDATE_REQUEST: update.request,
    CUSTOMERS_GET_TRANSACTIONS_REQUEST: getTransactions.request,
    CUSTOMERS_TOP_UP_REQUEST: topUp.request,
    CUSTOMERS_WITHDRAW_REQUEST: withdraw.request,
    CUSTOMERS_ADJUST_REQUEST: adjust.request,
    CUSTOMERS_SET_LIMIT_REQUEST: setLimit.request,
    CUSTOMERS_SET_WAGERING_LIMIT: setWageringLimit.request,
    CUSTOMERS_SELF_EXCLUSION_REQUEST: selfExclusion.request,
    CUSTOMERS_PLAY_BREAK_REQUEST: playBreak.request,
    CUSTOMERS_REALITY_CHECK_REQUEST: realityCheck.request,
    CUSTOMERS_GET_ASSET_FLOWS_REQUEST: getAssetFlows.request,
    CUSTOMERS_REMOVE_PAYMENT_METHOD_REQUEST: removePaymentMethods.request,
    CUSTOMERS_GET_COUNTERS_REQUEST: getCounters.request,

    CUSTOMERS_CURRENCY_VALIDATION_REQUEST: currencyValidation.request,
    CUSTOMERS_REFERAL_VALIDATION_REQUEST: referalValidation.request,

    CUSTOMERS_GET_FREEBET_CREDITS_REQUEST: getFreeBetCredits.request,
    CUSTOMERS_ADD_FREEBET_CREDITS_REQUEST: addFreeBetCredit.request,
    CUSTOMERS_REMOVE_FREEBET_CREDITS_REQUEST: removeFreeBetCredit.request,
    CUSTOMERS_GET_FREEBET_HISTORY_REQUEST: getFreeBetHistory.request,

    CUSTOMER_REQUEST_REACTIVATION_REQUEST: requestReactivation.request,
    CUSTOMER_REACTIVATE_REQUEST: reactivate.request,
};
